import { createFileRoute, redirect } from "@tanstack/react-router";

// Objectives are now managed directly in the planning workspace hierarchy tree;
// the standalone Objectives page redirects there, preserving the farm scope.
export const Route = createFileRoute(
	"/_auth/app/_app/org/$orgId/planning/objectives/",
)({
	// Pure redirect into the workspace — must stay traversable offline.
	staticData: { offline: "ready" },
	beforeLoad: ({ params, search }) => {
		throw redirect({
			to: "/app/org/$orgId/planning",
			params: { orgId: params.orgId },
			search: { farm: (search as { farm?: string }).farm, view: "board" },
		});
	},
});
